<template>
  <div class="draft-card">
    <div class="d-flex">
      <div class="d-flex justify-content-center">
        <i class="fa-regular fa-circle-exclamation mr-2 mt-1" />
      </div>
      <div class="d-flex flex-column">
        <span class="fs-14">Atenção</span>
        <span class="fs-12 text-dark-40">
          {{
            enable
              ? "A configuração necessária foi realizada, solicite ao suporte a aprovação do seu produto."
              : "Finalize as configurações necessárias para seguir com a solicitação de aprovação do seu produto."
          }}
        </span>
      </div>
    </div>

    <snow-button
      v-if="$config.get('whatsapp_support')"
      size="md"
      text="Solicitar aprovação"
      :disabled="!enable"
      @click="requestApproval"
    />
  </div>
</template>

<script>
import { approvalMessageUrl } from "@/functions/product";
export default {
  props: {
    product: {
      type: Object,
      default: () => ({})
    },
    enable: Boolean
  },
  methods: {
    requestApproval() {
      window.open(
        approvalMessageUrl(
          this.product,
          this.$user.user,
          this.$config.get("whatsapp_support")
        ),
        "_blank"
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.draft-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: var(--bg-4);
  border-radius: 16px;
  padding: 16px;
}
</style>
